export default __webpack_public_path__ + "static/media/video-slash.d1dd271a.svg";